// Mock data for TwinBrain Jewellery clone (frontend-only)

export const RATES = {
  gold24k: { value: 157400, unit: 'Per 10 grams', fineness: '999 Fineness' },
  silver: { value: 243500, unit: 'Per kilogram', fineness: '999 Fineness' },
  updated: '04 Sep 2026, 07:57 AM',
  city: 'Nagpur',
};

export const SMALL_RATES = [
  { label: '1g', name: 'Gold Coin', price: '₹16,000' },
  { label: '0.5g', name: 'Gold Coin', price: '₹8,000' },
  { label: '5g', name: 'Silver Coin', price: '₹1,220' },
];

export const HERO_STATS = [
  { value: '45%', label: 'Book now' },
  { value: '₹30', label: 'EMI/day' },
  { value: '24K', label: 'Pure gold' },
  { value: '32', label: 'Winners/month' },
];

export const LEASE_STEPS = [
  { n: 1, icon: 'Landmark', title: 'You Buy the Silver', desc: "Pay for hallmarked silver at today's store rate. Ownership is yours from day one — no middlemen.", tag: '999 Fineness' },
  { n: 2, icon: 'Handshake', title: 'You Lease It to Us', desc: 'Instead of taking it home, place your silver with TwinBrain on a fixed lease term.', tag: 'Flexible Tenure' },
  { n: 3, icon: 'TrendingUp', title: 'You Earn on It', desc: 'Receive fixed lease returns on schedule, with your silver fully accounted for throughout.', tag: 'Guaranteed Returns' },
];

export const SCHEME_BENEFITS = [
  { n: 1, icon: 'Bike', title: 'Chance to Win Bajaj Chetak!', desc: 'Every 10th month — win a brand new Bajaj Chetak electric scooter. Prize open on the 10th, 20th, 30th & 40th month.', tag: 'Every 10th Month' },
  { n: 2, icon: 'Coins', title: '5 Gram Gold Coin Prize!', desc: 'Win this exciting milestone prize on the 9th, 18th, 27th & 36th months. Pure 24K TwinBrain gold coin.', tag: 'Months 9, 18, 27 & 36' },
  { n: 3, icon: 'Gift', title: 'Exciting Prizes Every Month!', desc: 'From 1 gram Gold to 0.5 gram Gold to 5 gram Silver coin to 1 gram Silver coin — 32 winners every single month.', tag: '32 Winners / Month' },
  { n: 4, icon: 'Megaphone', title: 'Promote Your Business With Us!', desc: "We are up for any type of promotional event. Leverage TwinBrain's growing community for your business growth.", tag: 'Business Promotion' },
  { n: 5, icon: 'ScrollText', title: 'Long-Term Investment Security!', desc: "Secure your future with TwinBrain's guaranteed benefits. Certificate of investment. Money-back option after maturity.", tag: '40-Month Security' },
];

export const MONTHLY_PRIZES = [
  { icon: 'Medal', title: '1 Gram Gold Coin', sub: '1 winner every month', tag: '24K Gold' },
  { icon: 'Award', title: '0.5 Gram Gold Coin', sub: '1 winner every month', tag: '24K Gold' },
  { icon: 'Coins', title: '5 Gram Silver Coin', sub: '5 winners every month', tag: 'Pure Silver' },
  { icon: 'Coins', title: '1 Gram Silver Coin', sub: '25 winners every month', tag: 'Pure Silver' },
];

export const EMI_STEPS = [
  { n: 1, title: 'Choose your coin', desc: 'Gold or silver — any weight' },
  { n: 2, title: 'Pay 45% to book', desc: 'Coin reserved instantly' },
  { n: 3, title: 'Pay balance in EMIs', desc: 'Flexible · no hidden charges' },
  { n: 4, title: 'Take your coin home', desc: 'Collect once fully paid' },
];

export const PRODUCTS = [
  { weight: '1g', name: '1g Gold Coin', desc: '24K pure gold · BIS hallmarked · TwinBrain engraved', price: '₹16,000', tag: '24K Gold', metal: 'gold' },
  { weight: '0.5g', name: '0.5g Gold Coin', desc: '24K pure gold · Perfect gifting size · TwinBrain engraved', price: '₹8,000', tag: '24K Gold', metal: 'gold' },
  { weight: '5g', name: '5g Silver Coin', desc: 'Pure silver · Investment & gifting · TwinBrain engraved', price: '₹1,220', tag: 'Pure Silver', metal: 'silver' },
  { weight: '1g', name: '1g Silver Coin', desc: 'Pure silver · Affordable daily savings · TwinBrain engraved', price: '₹244', tag: 'Pure Silver', metal: 'silver' },
];

export const BUSINESS = [
  { icon: 'Megaphone', title: 'Event Promotion', desc: 'Promote at TwinBrain monthly draws & meets' },
  { icon: 'Users', title: 'Community Outreach', desc: 'Direct access to 200+ active investors in Nagpur' },
  { icon: 'Instagram', title: 'Social Media Collaboration', desc: 'Joint campaigns on Instagram & WhatsApp' },
  { icon: 'Target', title: 'Targeted Marketing', desc: 'Reach our audience with your brand message' },
];

export const CONTACTS = [
  { icon: 'Phone', title: '7620005111', sub: 'Call or WhatsApp' },
  { icon: 'Phone', title: '8329836788', sub: 'Call or WhatsApp' },
  { icon: 'MapPin', title: 'Nagpur, Maharashtra', sub: 'Visit our store' },
  { icon: 'Globe', title: 'twinbrainadvertisinglimited.com', sub: 'Website' },
];

export const INTEREST_OPTIONS = [
  'Golden Reward Scheme – ₹65,000',
  'Gold Coins (EMI Available)',
  'Silver Coins (EMI Available)',
  'Business Promotion / Partnership',
  'General Enquiry',
];

export const WINNERS_APRIL = [
  { rank: 'gold', name: 'JYOTI AHUJA', prize: '1 GRAM GOLD COIN', cat: '24K Gold' },
  { rank: 'silvermedal', name: 'SANGITA GEDAM', prize: '0.5 GRAM GOLD COIN', cat: '24K Gold' },
  { rank: 'coin', name: 'SANTOSH BIRLA', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: 'HUSSAIN', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: 'PRACHI GUMGAONKAR', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: 'ADITYA BAINGANE', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: 'AMEY REWATKAR', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
];

export const WINNERS_AUGUST = [
  { rank: 'gold', name: '28', prize: '1 GRAM GOLD COIN', cat: '24K Gold' },
  { rank: 'silvermedal', name: '61', prize: '0.5 GRAM GOLD COIN', cat: '24K Gold' },
  { rank: 'coin', name: '73', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '102', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '144', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '181', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '189', prize: '5 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '2', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '3', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '22', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '24', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '30', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '36', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '41', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '45', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '50', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
  { rank: 'coin', name: '99', prize: '1 GRAM SILVER', cat: 'Pure Silver' },
];

export const REVIEWS = [
  { name: 'Rahul Deshmukh', text: 'Bought a 5g gold coin on EMI — smooth process and genuine BIS hallmarked purity. Highly recommend TwinBrain in Nagpur.', rating: 5 },
  { name: 'Priya Kulkarni', text: 'Joined the Golden Reward Scheme and already won a silver coin! The team is transparent and very professional.', rating: 5 },
  { name: 'Amit Sharma', text: 'The silver lease plan gives me fixed returns without the hassle of storage. Trustworthy and reliable service.', rating: 5 },
  { name: 'Sneha Patil', text: 'Loved the gifting-size 0.5g gold coin. Beautiful TwinBrain engraving and delivered exactly as promised.', rating: 5 },
  { name: 'Vikram Rao', text: 'Excellent EMI options starting at just ₹30/day. Made owning gold affordable for my family.', rating: 5 },
  { name: 'Neha Joshi', text: 'The monthly lucky draw is exciting and the winners are real. Great community of investors in Nagpur.', rating: 5 },
];

export const NAV_LINKS = [
  { label: 'Live Rates', href: '#rates' },
  { label: 'Buy & Lease', href: '#lease' },
  { label: 'Reward Scheme', href: '#scheme' },
  { label: 'Coins', href: '#coins' },
  { label: 'Easy EMI', href: '#emi' },
  { label: 'Business', href: '#promo' },
  { label: 'Win Silver', href: '#luckydraw', highlight: true },
  { label: 'Winners', href: '#winners' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
];

export const WHATSAPP_NUMBER = '917620005111';

// Paid live bullion rates WhatsApp group.
// If inviteLink is set, the button opens it directly; otherwise it opens a
// WhatsApp chat to the number with a pre-filled subscribe message.
export const BULLION_GROUP = {
  paid: true,
  price: '₹500 / month',
  inviteLink: '',
  number: WHATSAPP_NUMBER,
  subscribeMessage: 'Hi TwinBrain! I want to subscribe to your PAID Live Bullion Rates WhatsApp group. Please share the payment & joining details.',
};
